module.exports = "/build/web/images/partner_uwschilderwerk.b722c8d20975c38e13247b4b2655c9d4.svg";


//////////////////
// WEBPACK FOOTER
// ./images/partner_uwschilderwerk.svg
// module id = 130
// module chunks = 11